import { Component, Inject, OnDestroy, OnInit, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';

interface VerificationSuccessDialogProps {
  title?: string;
  message?: string;
  primaryActionLabel?: string;
  primaryActionRoute?: string;
  secondaryActionLabel?: string;
  secondaryActionRoute?: string;
}

@Component({
  selector: 'fz-verification-success-dialog',
  templateUrl: './verification-success-dialog.component.html',
  styleUrls: ['./verification-success-dialog.component.scss'],
})
export class VerificationSuccessDialogComponent implements OnInit, OnDestroy {
  config: VerificationSuccessDialogProps;

  isKycForce = signal(true);

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: VerificationSuccessDialogProps,
    private readonly dialog: MatDialogRef<VerificationSuccessDialogComponent>,
  ) {
    this.config = {
      title: 'Thank you!',
      message:
        "Your player profile is completed and verified. You're all set to start playing in our free tournaments or load your wallet to participate in paid ones. Start having fun!",
      primaryActionLabel: 'Load My Wallet',
      primaryActionRoute: '/wallet',
      secondaryActionLabel: 'Check out our tournaments',
      secondaryActionRoute: '/tournaments',
      ...data,
    };
  }
  ngOnInit(): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { m: 'verification-success' },
      replaceUrl: true,
      queryParamsHandling: 'merge',
    });
  }

  ngOnDestroy(): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { m: null },
      replaceUrl: true,
      queryParamsHandling: 'merge',
    });
  }

  get page(): 'claim-prize' | string {
    const location = this.router.url.split('?')[0];

    if (location.includes('personal-info/winner')) {
      return 'claim-prize';
    }

    return '';
  }
}
